import { tv } from "tailwind-variants";

export const getInputClass = tv({
  base: [
    "peer",
    "flex w-full rounded-lg border border-input bg-transparent px-4 pt-5 pb-2 font-semibold text-base ring-offset-background",
    "file:border-0 file:bg-transparent file:font-semibold file:text-sm",
    "placeholder:text-transparent placeholder-shown:pt-5 focus-visible:placeholder:text-gray-500",
    "focus-visible:pt-5 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
    "disabled:cursor-not-allowed disabled:opacity-50",
  ],
});
